"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class WebsiteModel {
    constructor(label, url) {
        this.label = label;
        // support url as an existing WebsiteModel or as a string
        this.url = (url instanceof Object) ? url.url : url;
    }
}
exports.WebsiteModel = WebsiteModel;
//# sourceMappingURL=website.model.js.map